import { DataRoomStatus } from 'further-types/data-room';
import { Realm } from 'further-types/global';
import { z } from 'zod';

export const GetDataRoomInput = z.object({
  id: z.string(),
});

export const CreateDataRoomInput = z.object({
  realm: z.nativeEnum(Realm),
  linkedToId: z.string(),
});

export const UpdateDataRoomInput = z.object({
  id: z.string(),
  contact: z.object({
    name: z.string(),
    email: z.string(),
    phone: z.string(),
    image: z.string(),
  }),
  headline: z.string(),
  subheading: z.string(),
  keyInformation: z.array(
    z.object({ fieldName: z.string(), value: z.string() }),
  ),
});

export const SetDataRoomStatusInput = z.object({
  id: z.string(),
  statusToSet: z.nativeEnum(DataRoomStatus),
});
